<template>
  <div class="listFacilities">
    <v-card>
      <v-card-title>
        Facilities
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('GeneralTranslations.Search')"
          single-line
          hide-details
          style="max-width: 300px; margin-top: 15px;"
        ></v-text-field>

        <v-dialog v-model="orgDialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-5 mt-5">Create Org</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Create Org</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="newOrgName" label="Org Name*" required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>*
              <small>{{$t('GeneralTranslations.StarIndicatesRequiredField')}}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="cancelOrgCreatePopup">{{$t('GeneralTranslations.Cancel')}}</v-btn>
              <v-btn color="blue darken-1" text @click="createOrg">{{$t('GeneralTranslations.Create')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-5 mt-5">Create Facility</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Create Facility</span>
            </v-card-title>
            <v-card-text>
              <v-container v-if='creatingFacility'>
                <div class="text-center">
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="purple"
                    indeterminate
                  ></v-progress-circular>
                  Creating facilty, this takes 8 seconds..
                </div>
              </v-container>
              <v-container v-if='!creatingFacility'>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="newFacilityName" label="Name*" required></v-text-field>
                    <v-autocomplete v-model="newOrg" :items="buddyOrganisationsList" return-object item-text="name" item-value="id" label="Organisation*" @change="getRegions" required></v-autocomplete>
                    <v-select v-model="newRegion" v-if="newOrg !=null" return-object :items="regions" item-text="name" label="Region"></v-select>
                    <v-text-field v-model="newBaseUrl" required label="Base Url"></v-text-field>
                    <v-text-field v-model="newRefId" required label="Ref ID"></v-text-field>
                    Ref ID is the Hubspot Location ID if integrating with MCare.
                  </v-col>
                </v-row>
                <small>{{$t('GeneralTranslations.StarIndicatesRequiredField')}}</small>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="cancelFacilityCreatePopup">{{$t('GeneralTranslations.Cancel')}}</v-btn>
              <v-btn color="blue darken-1" :loading="isCreatingFacilityLoading" text @click="createFacility">{{$t('GeneralTranslations.Create')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="buddyFacilities"
        :loading="isFacilitiesLoading"
        :search="search"
        @click:row="handleClickFacility"
      >
      <template v-slot:item.dateTimeCreated="{ item }">
          <span v-if="item.dateTimeCreated">{{ (item.dateTimeCreated.seconds * 1000)| localizedDate(facility.dateFormat) }}</span>
      </template>
      
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "facilitiesList",
  components: {},
  computed: mapState({
    regions: (state) => state.buddyModule.currentRegions,
    facility: (state) => state.facilityModule.selectedFacility
  }),
  data() {
    return {
      dialog :false,
      orgDialog:false,
      isCreatingFacilityLoading: false,
      isFacilitiesLoading: false,
      currentDate: new Date().getDate(),
      search: "",
      newFacilityName: "",
      newBaseUrl: "pcs.getreshub.com",
      newRefId: "",  //hubspotId
      creatingFacility: false,
      newOrg: null,
      buddyFacilities: [],
      buddyOrganisationsList: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Region",
          align: "start",
          sortable: false,
          value: "regionName",
        },
        {
          text: "Organisation",
          align: "start",
          sortable: false,
          value: "orgName",
        },
        {
          text: "Creation date",
          align: "start",
          sortable: false,
          value: "dateTimeCreated",
        },

      ],
    };
  },
  async created() {
    this.isFacilitiesLoading = true;
    this.buddyFacilities = await this.$store.dispatch("getBuddyFacilities");
    this.isFacilitiesLoading = false;
    this.buddyOrganisationsList = await this.$store.dispatch("getBuddyOrgs");
  },
  methods: {
    handleClickFacility(row) {
      console.log(row)
      this.$store.dispatch('getFacilitiesForOrg', row.orgId);
      this.$store.dispatch('getFacilityEmailTemplates', row.id);
      this.$router.push("/buddy/facilities/" + row.id.toString());
    },
    async createFacility(){
      try {
        this.isCreatingFacilityLoading = true
        await this.$store.dispatch("createBuddyFacility",  {facilityName: this.newFacilityName, baseUrl: this.newBaseUrl, refId: this.newRefId ,regionId: this.newRegion?.id, regionName: this.newRegion?.name, orgId: this.newOrg.id, orgName: this.newOrg.name });
        this.newOrg = null;
        this.newRegion=null;
        this.creatingFacility= true;
        this.newFacilityName = null;
        this.newBaseUrl = null;
        this.newRefId = null;
        this.isCreatingFacilityLoading = false
        this.dialog = false
      } catch (error) {
        console.error("Error creating facility:", error)
      } finally {
        this.creatingFacility = false;
        console.log('here')
      }
    },
    async createOrg(){
      await this.$store.dispatch("createBuddyOrg", { name: this.newOrgName });
      this.orgDialog = false;
      this.buddyOrganisationsList = await this.$store.dispatch("getBuddyOrgs");
    },
    getRegions(){
      this.$store.dispatch("getBuddyRegions",  this.newOrg.id);
    },
    cancelFacilityCreatePopup(){
      //  this.dialog = false;
      this.newOrg = null;
      this.newRegion=null;
      this.newFacilityName = null;
      this.newBaseUrl = null;
      this.newRefId = null;
      this.dialog= false;
    },
    cancelOrgCreatePopup(){
      this.orgDialog = false;
      this.newOrgName = null;
    }
  },
};
</script>
